import {
  browserName,
  fullBrowserVersion,
  isEdge,
  isOpera,
  isSafari,
  isFirefox,
  isChrome
} from "react-device-detect";
import { axiosInstance } from "../config/configApi";

let terminalOsType = null;
switch (true) {
  case isChrome:
    terminalOsType = "WebChrome";
    break;
  case isSafari:
    terminalOsType = "WebSafari";
    break;
  case isEdge:
    terminalOsType = "WebEdge";
    break;
  case isFirefox:
    terminalOsType = "WebChrome";
    break;
  case isOpera:
    terminalOsType = "WebChrome";
    break;
  default:
    terminalOsType = "Web";

    break;
}

const postAnalyticsLoginEvent = async (profileId) => {
  return await axiosInstance.post("analytics-client/event/login", null, {
    params: { profileId: profileId },
    headers: {
      "Device-Type": terminalOsType
    }
  });
};
const postAnalyticsVodWatch = async (id, profileId) => {
  return await axiosInstance.post(
    `analytics-client/event/vod-watch/${id}`,
    null,
    {
      params: { profileId: profileId },
      headers: {
        "Device-Type": terminalOsType
      }
    }
  );
};
const postAnalyticsLtvWatch = async (id, duration, profileId) => {
  return await axiosInstance.post(
    `analytics-client/event/ltv-watch/${id}`,
    null,
    {
      params: { duration: duration, profileId: profileId },
      headers: {
        "Device-Type": terminalOsType
      }
    }
  );
};

export {
  postAnalyticsLoginEvent,
  postAnalyticsVodWatch,
  postAnalyticsLtvWatch
};
